import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShare = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 10.7468C11.4933 10.7468 11.04 10.9468 10.6933 11.2601L5.94 8.49344C5.97333 8.34011 6 8.18677 6 8.02677C6 7.86677 5.97333 7.71344 5.94 7.56011L10.64 4.82011C11 5.15344 11.4733 5.36011 12 5.36011C13.1067 5.36011 14 4.46677 14 3.36011C14 2.25344 13.1067 1.36011 12 1.36011C10.8933 1.36011 10 2.25344 10 3.36011C10 3.52011 10.0267 3.67344 10.06 3.82677L5.36 6.56677C5 6.23344 4.52667 6.02677 4 6.02677C2.89333 6.02677 2 6.92011 2 8.02677C2 9.13344 2.89333 10.0268 4 10.0268C4.52667 10.0268 5 9.82011 5.36 9.48677L10.1067 12.2601C10.0733 12.4001 10.0533 12.5468 10.0533 12.6934C10.0533 13.7668 10.9267 14.6401 12 14.6401C13.0733 14.6401 13.9467 13.7668 13.9467 12.6934C13.9467 11.6201 13.0733 10.7468 12 10.7468Z",
		fill: "currentColor"
	})
});
export default SvgShare;
